/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  GenerateProfitLossReportFilterOptions,
  ProfitLossReport,
} from "../models/index";
import {
  GenerateProfitLossReportFilterOptionsFromJSON,
  GenerateProfitLossReportFilterOptionsToJSON,
  ProfitLossReportFromJSON,
  ProfitLossReportToJSON,
} from "../models/index";

export interface GenerateProfitLossReportRequest {
  generateProfitLossReportFilterOptions: GenerateProfitLossReportFilterOptions;
}

/**
 *
 */
export class ProfitLossApi extends runtime.BaseAPI {
  /**
   */
  async generateProfitLossReportRaw(
    requestParameters: GenerateProfitLossReportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ProfitLossReport>> {
    if (requestParameters["generateProfitLossReportFilterOptions"] == null) {
      throw new runtime.RequiredError(
        "generateProfitLossReportFilterOptions",
        'Required parameter "generateProfitLossReportFilterOptions" was null or undefined when calling generateProfitLossReport().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/profit-loss/generate-profit-loss-report`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: GenerateProfitLossReportFilterOptionsToJSON(
          requestParameters["generateProfitLossReportFilterOptions"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProfitLossReportFromJSON(jsonValue),
    );
  }

  /**
   */
  async generateProfitLossReport(
    requestParameters: GenerateProfitLossReportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ProfitLossReport> {
    const response = await this.generateProfitLossReportRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
